import api from "./axios";

export const listEmployees = (params = {}) => api.get("/employees", { params });
export const employeeStats = () => api.get("/employees/stats");
export const getEmployee = (id) => api.get(`/employees/${id}`);
export const createEmployee = (payload) => api.post("/employees", payload);
export const updateEmployee = (id, payload) => api.put(`/employees/${id}`, payload);
export const deleteEmployee = (id) => api.delete(`/employees/${id}`);
export const markEmployeeLeft = (id) => api.patch(`/employees/${id}/leave`);
// Issues a fresh one-time temp password and revokes their sessions.
export const resetEmployeePassword = (id) => api.post(`/employees/${id}/reset-password`);
export const rejoinEmployee = (id) => api.patch(`/employees/${id}/rejoin`);
export const getPermissionsCatalog = () => api.get("/employees/permissions-catalog");
export const syncEmployeePermissions = (id, permissions) =>
  api.put(`/employees/${id}/permissions`, { permissions });
